import { Button, type ButtonProps } from '@chakra-ui/react';

/** The brand-yellow action that sits beside a primary one. Styling: `visual.secondary`. */
const SecondaryButton = (props: ButtonProps) => <Button visual="secondary" {...props} />;

export default SecondaryButton;
